import { render, staticRenderFns } from "./video-edit.vue?vue&type=template&id=db1eabb6&scoped=true&"
import script from "./video-edit.vue?vue&type=script&lang=js&"
export * from "./video-edit.vue?vue&type=script&lang=js&"
import style0 from "./video-edit.vue?vue&type=style&index=0&id=db1eabb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1eabb6",
  null
  
)

export default component.exports